import React, { useState, useEffect } from 'react';
import api from '../api/apiHelper';

const ReconsentModal = ({ consentInfo, onAccepted }) => {
  const [policyContent, setPolicyContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isAccepted, setIsAccepted] = useState(false);

  // Mapa do wyświetlania ładnych nazw dokumentów
  const documentNameMap = {
    TERMS_OF_SERVICE: 'Regulamin',
    PRIVACY_POLICY: 'Politykę Prywatności',
  };

  useEffect(() => {
    const fetchPolicy = async () => {
      setIsLoading(true);
      try {
        // Pobieramy treść polityki z backendu
        const response = await api.get(`/policies/latest/${consentInfo.type.toLowerCase()}/`);
        
        // <<< POPRAWKA JEST TUTAJ
        // Dane z axios są w polu `response.data`, a treść HTML w `response.data.content`
        setPolicyContent(response.data.content);

      } catch (error) {
        console.error("Błąd ładowania treści polityki:", error);
        setPolicyContent("<p>Nie udało się załadować treści dokumentu. Spróbuj odświeżyć stronę.</p>");
      } finally {
        setIsLoading(false);
      }
    };

    fetchPolicy();
  }, [consentInfo.type]); // Efekt uruchamia się, gdy zmieni się typ dokumentu do wyświetlenia

  const handleAccept = async () => {
    if (!isAccepted) return;
    try {
      // Wysyłamy nową zgodę z numerem najnowszej wersji
      await api.post('/record-consent/', {
        consent_type: consentInfo.type,
        status: 'GRANTED',
        version: consentInfo.data.latest_version,
      });
      // Informujemy App.js, że zgoda została wyrażona i można zamknąć modal
      onAccepted();
    } catch (error) {
      alert("Wystąpił błąd podczas zapisywania zgody. Spróbuj ponownie.");
    }
  };

  return (
    // Cały JSX pozostaje bez zmian
    <div className="fixed inset-0 z-50 bg-black bg-opacity-75 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
        <div className="p-6 border-b">
          <h2 className="text-2xl font-bold text-gray-800">Ważna aktualizacja</h2>
          <p className="text-gray-600 mt-1">
            Zaktualizowaliśmy naszą {documentNameMap[consentInfo.type] || 'dokumentację'}. Prosimy o zapoznanie się z nową wersją ({consentInfo.data.latest_version}) i jej akceptację.
          </p>
        </div>

        <div className="p-6 overflow-y-auto">
          {isLoading ? (
            <p>Ładowanie treści...</p>
          ) : (
            // `prose` to klasa z pluginu Tailwind CSS Typography, która ładnie styluje HTML
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: policyContent }} />
          )}
        </div>

        <div className="p-6 border-t bg-gray-50 rounded-b-lg">
          <div className="flex items-center mb-4">
            <input
              type="checkbox"
              id="reconsent-checkbox"
              checked={isAccepted}
              onChange={(e) => setIsAccepted(e.target.checked)}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <label htmlFor="reconsent-checkbox" className="ml-2 text-sm text-gray-700">
              Przeczytałem/am i akceptuję nową wersję dokumentu.
            </label>
          </div>
          <button
            onClick={handleAccept}
            disabled={!isAccepted || isLoading}
            className="w-full bg-blue-600 text-white font-bold py-2 px-4 rounded disabled:bg-gray-400 disabled:cursor-not-allowed hover:bg-blue-700 transition-colors"
          >
            Zatwierdź i kontynuuj
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReconsentModal;